/*------------------------------------*\
    MODULES
\*------------------------------------*/
class Scroll {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        //self.scrollElem = self.elem.querySelector('[data-scroll]');
        self.scrollCardElems = self.elem.querySelectorAll('[data-scroll-card]');
        
        
        




    }

    init() {
        let self = this;
        self.initMaps();

    }

    initMaps() {
        let self = this;
        
        self.createListeners(self);

        self.redefinePosition(self);

        self.elem.scrollLeft = '200';

        if(window.innerWidth < parseInt(getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-lg'))){
            self.scrollCardElems.forEach(scrollCardElem => {
                scrollCardElem.style.left = '200px';

            });
        }
        


    }

    createListeners(self) {
        document.addEventListener('DOMContentLoaded', function () {
                
            self.elem.addEventListener("scroll", (event) => {
                self.redefinePosition(self);
            });

            window.addEventListener("resize", (event) => {
                 self.redefinePosition(self);
                 self.elem.scrollLeft = '200';

            });


            
        });
    }
    redefinePosition(self){
        if(window.innerWidth < parseInt(getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-lg'))){
                    
            self.scrollCardElems.forEach(scrollCardElem => {
                scrollCardElem.style.left = self.elem.scrollLeft+'px';


            });
        }
        else{
            self.scrollCardElems.forEach(scrollCardElem => {
                scrollCardElem.style.left = scrollCardElem.getAttribute('data-scroll-card-x')+"%";


            });

        }

    }
 
}

export default Scroll;